import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import BackToTop from '@/components/base/BackToTop';

const teamValues = [
  {
    icon: 'ri-search-eye-line',
    title: '追问到底',
    desc: '一条线索从收到到核实，往往需要数轮沟通与多方求证。我们不轻易放弃，也不轻易发布。',
  },
  {
    icon: 'ri-shield-user-line',
    title: '保护信源',
    desc: '对于每一位通过17爆料投稿或私信提供线索的人，我们对其身份信息保持绝对保密，这是不可妥协的职业底线。',
  },
  {
    icon: 'ri-scales-3-line',
    title: '兼听则明',
    desc: '报道在发布前，我们会联系各方当事人，给每一方表达立场的机会，确保呈现不偏不倚的完整事实。',
  },
  {
    icon: 'ri-focus-3-line',
    title: '专注公共利益',
    desc: '我们优先处理具有社会普遍意义的线索，尤其是那些涉及集体权益、可能影响更多人的事件。',
  },
];

const timeline = [
  { year: '2021', event: '17爆料平台上线，聚焦消费维权领域，首月收到线索逾200条。' },
  { year: '2022', event: '报道栏目扩展至社会民生、食品安全、物业纠纷等领域，累计发布报道突破100篇。' },
  { year: '2023', event: '与多个地方消费者协会建立信息共享机制，核实效率大幅提升。' },
  { year: '2024', event: '推出匿名投稿系统，17爆料私信通道正式开放，投稿量同比增加180%。' },
  { year: '2025', event: '累计发布核实报道300篇，累计收到线索超过3500条，推动多起事件得到官方回应。' },
  { year: '2026', event: '平台持续运营，扩展至8大报道栏目，继续服务于有话想说的每一位普通人。' },
];

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于17爆料',
  url: 'https://xodxd.cn/about',
  description: '17爆料是一个线索征集与核实发布平台，成立于追求新闻真实性与公共利益的信念，为普通人提供可信的发声出口。',
  publisher: { '@id': 'https://xodxd.cn/#org' },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首页', item: 'https://xodxd.cn/' },
    { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://xodxd.cn/about' },
  ],
};

export default function AboutPage() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
      <Navbar />
      <main className="pt-16">
        {/* Hero */}
        <div className="relative bg-foreground-950 py-16 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20dark%20paper%20texture%20with%20handwritten%20notes%20and%20editorial%20marks%2C%20warm%20amber%20and%20charcoal%20ink%20tones%2C%20journalism%20newsroom%20editorial%20aesthetic%2C%20minimalist%20composition%2C%20high%20contrast%20documentary%20style&width=1600&height=500&seq=about-hero-bg-01&orientation=landscape"
            alt=""
            aria-hidden="true"
            className="absolute inset-0 w-full h-full object-cover object-top opacity-15"
          />
          <div className="relative max-w-6xl mx-auto px-4 md:px-6">
            <nav aria-label="面包屑" className="text-xs text-background-500 mb-5">
              <ol className="flex items-center gap-1.5 flex-wrap">
                <li><Link to="/" className="hover:text-background-300 transition-colors">首页</Link></li>
                <li><i className="ri-arrow-right-s-line" /></li>
                <li className="text-background-300">关于我们</li>
              </ol>
            </nav>
            <div className="max-w-3xl">
              <h1 className="font-heading text-4xl md:text-5xl font-black text-background-50 mb-5 leading-tight">
                关于 <span className="text-primary-400">17爆料</span>
              </h1>
              <p className="text-background-300 text-base md:text-lg leading-relaxed">
                我们相信：每一个身边的真实故事，都值得被认真对待。17爆料成立于「让真相被更多人看到」的朴素信念，是一个为普通人提供可信发声出口的线索征集与核实发布平台。
              </p>
            </div>
          </div>
        </div>

        {/* Mission */}
        <section className="bg-background-50 py-14 md:py-20" aria-labelledby="mission-heading">
          <div className="max-w-6xl mx-auto px-4 md:px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div>
              <h2 id="mission-heading" className="headline-divider font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-5">
                我们是谁
              </h2>
              <div className="flex flex-col gap-4 text-sm text-foreground-700 leading-relaxed">
                <p>
                  17爆料是一个独立运营的线索征集与核实发布平台。自2021年上线以来，我们专注于收集、核实并发布具有公共利益价值的新闻线索，涵盖消费维权、食品安全、物业纠纷、交通安全、网络欺诈等多个领域。
                </p>
                <p>
                  我们不是一个简单的投诉平台，也不是舆论放大器。17爆料的工作流程是：<strong>先核实，后发布</strong>。编辑部对每一条线索进行多方求证，只有经过充分核实的内容才会对外发布。我们宁愿发得慢一些，也绝不发布未经核实的内容。
                </p>
                <p>
                  从第一篇报道到今天，我们累计发布了超过380篇核实报道，推动了数十起事件获得官方回应或得到实质解决。但我们更在意的，是让每一位选择相信我们、通过17爆料投稿或私信提供线索的普通人，感受到自己的声音真的被认真对待了。
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Journalists%20working%20in%20editorial%20newsroom%2C%20warm%20lamp%20light%2C%20documents%20and%20notes%20on%20desk%2C%20focused%20concentration%2C%20documentary%20photography%20style%2C%20warm%20amber%20and%20beige%20tones%2C%20cinematic%20editorial%20composition&width=700&height=500&seq=about-team-01&orientation=landscape"
                alt="17爆料编辑部工作场景"
                className="w-full rounded-lg object-cover object-top h-72 md:h-80"
              />
              <div className="absolute -bottom-4 -left-4 bg-primary-500 text-background-50 rounded-lg px-5 py-3">
                <p className="font-heading text-2xl font-bold">380+</p>
                <p className="text-xs text-primary-100">已核实发布报道</p>
              </div>
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="bg-background-100 py-14 md:py-20" aria-labelledby="values-heading">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 id="values-heading" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
                我们的工作原则
              </h2>
              <p className="text-foreground-600 text-sm max-w-xl mx-auto">
                这四条原则贯穿17爆料的每一篇报道，是我们对读者和投稿人最基本的承诺。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {teamValues.map((v) => (
                <div key={v.title} className="flex gap-4 bg-background-50 border border-background-200 rounded-lg p-5">
                  <div className="w-10 h-10 flex items-center justify-center rounded bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className={`${v.icon} text-xl`} />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-foreground-900 mb-1.5">{v.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Timeline */}
        <section className="bg-background-50 py-14 md:py-20" aria-labelledby="timeline-heading">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 id="timeline-heading" className="headline-divider font-heading text-2xl font-bold text-foreground-950 mb-10">
              发展历程
            </h2>
            <div className="relative flex flex-col gap-0 pl-6 border-l-2 border-background-300">
              {timeline.map((item) => (
                <div key={item.year} className="relative pb-8 last:pb-0">
                  <span className="absolute -left-[calc(0.5rem+1px)] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50" />
                  <span className="inline-block mb-1.5 text-xs font-bold text-primary-600 bg-primary-50 px-2 py-0.5 rounded">{item.year}</span>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.event}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="bg-foreground-950 py-14" aria-labelledby="contact-heading">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 id="contact-heading" className="font-heading text-2xl font-bold text-background-50 mb-8">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
              {[
                { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tips@17baoliao.com', sub: '线索与私信' },
                { icon: 'ri-customer-service-line', label: '编辑联络', value: 'editor@17baoliao.com', sub: '媒体合作' },
                { icon: 'ri-feedback-line', label: '读者反馈', value: 'feedback@17baoliao.com', sub: '报道勘误' },
              ].map((c) => (
                <div key={c.label} className="bg-foreground-900 rounded-lg p-5">
                  <div className="w-9 h-9 flex items-center justify-center rounded bg-primary-500/20 text-primary-400 mb-3">
                    <i className={`${c.icon} text-lg`} />
                  </div>
                  <p className="text-xs text-background-500 mb-0.5">{c.label}</p>
                  <a
                    href={`mailto:${c.value}`}
                    rel="nofollow"
                    className="text-sm font-medium text-background-200 hover:text-primary-400 transition-colors break-all"
                  >
                    {c.value}
                  </a>
                  <p className="text-xs text-background-500 mt-0.5">{c.sub}</p>
                </div>
              ))}
            </div>
            <div className="text-center">
              <p className="text-sm text-background-400 mb-5">有线索想发声？这是最直接的方式——</p>
              <Link
                to="/submit"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-md transition-colors whitespace-nowrap"
              >
                <i className="ri-send-plane-fill" /> 前往17爆料投稿
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}